import { createTheme } from '@mantine/core';
import { figtree } from '@/metadata/next-fonts/figtree';
export const mantineTheme = createTheme({ fontFamily: figtree.style.fontFamily, lineHeights: { xs: '1.5' } });
